'use client';
import { useEffect, useMemo } from 'react';

interface ArticleItem {
    id: number;
    Title: string;
}

export default function TitleList({ data }: { data: any }) {
    const ArticleList = useMemo(() => data?.ArticleList || [], [data]);

    useEffect(() => {
        const handleScroll = (id: string) => {
            const section = document.getElementById(id);
            if (section) {
                const yOffset = -75;
                const y = section.getBoundingClientRect().top + window.scrollY + yOffset;
                window.scrollTo({ top: y, behavior: 'smooth' });
            }
        };

        const addClickListener = (elementId: string, targetId: string) => {
            const element = document.getElementById(elementId);
            if (element) {
                element.addEventListener('click', () => handleScroll(targetId));
            }
        };

        ArticleList.forEach((Item: ArticleItem) => {
            addClickListener(`scroll-${Item.id}`, `section-${Item.id}`);
        });

        return () => {
            ArticleList.forEach((Item: ArticleItem) => {
                const element = document.getElementById(`scroll-${Item.id}`);
                if (element) {
                    element.removeEventListener('click', () => handleScroll(`section-${Item.id}`));
                }
            });
        };
    }, [ArticleList]);

    if (!data) {
        return <div>Failed to load data</div>;
    }

    return (
        <section className={`bg-[#f7f7f7] px-4 py-6 my-8`}>
            <div className={`font-bold mb-4`}>Table of Contents</div>
            <ol>
                {ArticleList.map((Item: ArticleItem) => (
                    <li key={Item.id} id={`scroll-${Item.id}`} className="cursor-pointer hover:text-[#00b6ff]">
                        {Item.Title}
                    </li>
                ))}
            </ol>
        </section>
    );
}
